import { StandardAlert } from '@brandfolder/react';
import React, { FunctionComponent } from 'react';

import { findCurrentLanguageInMap, Locale } from '@components/common/language_menu/languagesMap';

interface UGTAlertProps {
  locale: Locale;
}

export const UGTAlert: FunctionComponent<UGTAlertProps> = ({ locale }) => {
  if (!BFG.hasFeature('translations') || !BFG.locales?.ugtLocaleDefault || locale === BFG.locales.ugtLocaleDefault) {
    return null;
  }

  const { language } = findCurrentLanguageInMap(locale);

  return (
    <StandardAlert>
      {bfTranslate('You are now in edit mode for the language:')}&nbsp;
      <strong>{language}</strong>.&nbsp;
      {bfTranslate('Edits made will only display for users who select')}&nbsp;
      <strong>{language}</strong>&nbsp;
      {bfTranslate('as their language from the asset info language selector in the View Options.')}
    </StandardAlert>
  );
};